import React from 'react';
import { BeautifulMentionsMenuProps } from 'lexical-beautiful-mentions';

const MentionsMenu = ({ loading, ...props }: BeautifulMentionsMenuProps) => {
  return (
    <div style={{ zIndex: 9999 }} className="relative">
      <ul
        className="absolute mt-1 max-h-60 overflow-auto rounded-lg border border-gray-200 bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
        {...props}
      >
        {/* {loading && (
          <div className="flex items-center justify-center py-4 min-h-40">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-teal-500"></div>
          </div>
        )} */}
      </ul>
    </div>
  );
};

export default MentionsMenu;
